import { useLayoutEffect, useRef } from 'react';

export default function PlaySceneCards({ children }) {
  const stripRef = useRef(null);
  useLayoutEffect(() => {
    const strip = stripRef.current;
    let headings = [];
    const measure = () => {
      const height = Math.max(0, ...headings.map(heading => heading.getBoundingClientRect().height));
      strip.style.setProperty('--play2-card-title-height', `${height}px`);
    };
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    const observeHeadings = () => {
      resize?.disconnect();
      headings = [...strip.querySelectorAll('.play2-card h2, .play2-card h3')];
      headings.forEach(heading => resize?.observe(heading));
      measure();
    };
    const mutations = new MutationObserver(observeHeadings);
    mutations.observe(strip, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', measure);
    observeHeadings();
    return () => {
      resize?.disconnect(); mutations.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);
  return <section ref={stripRef} className="play2-card-strip" aria-label="Current scene cards">{children}</section>;
}
